export function isAbsoluteUrl(url) {
  return url.startsWith("http");
}
export function isCMSImage(src) {
  return src.startsWith("/cms");
}
export function getPath(src) {
  if (isAbsoluteUrl(src))
    return src;
  return `s3:/${src}`;
}
export function isRelativeNonCdnImage(src) {
  return !isCMSImage(src) && !isAbsoluteUrl(src);
}
export function isNonProxySrc(src) {
  return /(.)+\.(mp4|svg|gif)$/.test(`${src}`);
}
;
export function validateSize(size) {
  if (size === void 0)
    return void 0;
  const parsedSize = typeof size === "string" ? Number.parseInt(size, 10) : size;
  return Number.isNaN(parsedSize) ? void 0 : parsedSize;
}
